<template>
  <div class="reviewDetail">
    <div>
      <SfLink href="#" @click="apply" link="''" v-if="!reviews || (reviews && reviews.length == 0)">
        {{ $t('Go_To_Order_review') }}
      </SfLink>
      <div v-if="reviews && reviews.length">
        <SfRating :score="reviewGetters.getReviewRating(newLastOne)" /><br />
        <SfAccordion class="productAcction" v-if="false">
          <SfAccordionItem class="filters__accordion-item" :header="$t('reviewDetail')">
            <div>
              <div class="product__description">
                {{ reviewGetters.getReviewMessage(newLastOne) }}
              </div>
              <div>
                <div class="reviewImageList" style="display: flex;flex-wrap: wrap;gap: 1rem;">
                  <div v-if="newLastOne && newLastOne.videoUrl">
                    <video :autoplay="false" muted preload="load" loop
                      :src="newLastOne.videoUrl" :width="'100%'"
                      :height=" '100%'" style="object-position: top;max-height:150px;max-width: 150px;"
                      controls="controls" playsinline>
                      <source :src="newLastOne.videoUrl" :type="'video/*'">
                    </video>
                  </div>
                  <Sf-image v-for="imgsrc in reviewGetters.getReviewImages(newLastOne)" style="--image-height:150px;object-fit: contain;margin:0;display: block;" :src="imgsrc" :alt="imgsrc" />
                </div>
              </div>
            </div>
          </SfAccordionItem>
        </SfAccordion>
      </div>
    </div>
    <!-- <SfModal :title="$t('order_review')" :visible="visible" cross overlay :persistent="true" @close="closeModal"
      class="modalShouHou">
      <form class="afterForm">
        <div>
          <div style="margin: 5px">{{ $t('Items') }}: {{ itemName }}</div>
          <Reviewrating @jia-grade="jia1" @jian-grade="jian1" />
          <div style="margin-left: 5px; margin-top: 15px">
            <SfTextarea class="reviewContent" :value="form.reviewContent" :label="$t('Review_Content')" name="review_content" type="text"
              :icon="{ icon: '', color: '', size: '' }" valid
              errorMessage="Error message value of form input. It appears if `valid` is `false`." :required="false"
              :disabled="false" :hasShowPassword="false" placeholder="" v-model="form.reviewContent" />
          </div>
        </div>
        <div>
          <SfButton type="button" @click="saveReview">{{
            $t('save_order_review')
          }}</SfButton>
        </div>
      </form>
    </SfModal> -->
    <confirmModal
        ref="reviewModal"
        @close="closeReviewModal"
        :showFooter="false"
        class="reviewModal"
      >
      <form class="afterForm" slot="context">
        <div>
          <div style="margin: 5px">{{ $t('Items') }}: {{ itemName }}</div>
          <Reviewrating @jia-grade="jia1" @jian-grade="jian1" />
          <SfHeading
            :level="5"
            :title="$t('image')"
            style="margin-top:0.5rem"
            class="sf-heading--left sf-heading--no-underline title"
          />
          <div style=" display: flex;flex-wrap: wrap;gap: 1rem;">
            <div v-for="(image, index) in imageList">
              <uploadFile @uploadOk="$event => backImage($event, index)" />
            </div>
          </div>
          <SfHeading
            :level="5"
            :title="$t('video')"
            style="margin-top:0.5rem"
            class="sf-heading--left sf-heading--no-underline title"
          />
          <div style=" display: flex;flex-wrap: wrap;gap: 1rem; margin-top:0.25rem;">
            <div >
              <upload-file @uploadOk="backVideo" type="video" />
            </div>
          </div>
          <div style="margin-left: 5px; margin-top: 2rem;">
            <SfTextarea :value="form.reviewContent" :label="$t('Review_Content')" name="review_content" type="text"
              :icon="{ icon: '', color: '', size: '' }" valid
              errorMessage="Error message value of form input. It appears if `valid` is `false`." :required="false"
              :disabled="false" :hasShowPassword="false" placeholder="" v-model="form.reviewContent" />
          </div>
        </div>
        <!-- <div>
          <SfButton type="button" @click="saveReview">{{
            $t('save_order_review')
          }}</SfButton>
        </div> -->
      </form>
      <div slot="footer" style="text-align:center;display: flex; justify-content: end;">
        <sf-button class="mini-btn" @click="closeReviewModal"
          style="margin:1rem;background:#fff;color:#000;border:1px solid #dee0e3;margin-right:0;">
          {{ $t('cancel') || cancelText }}
        </sf-button>
        <sf-button class="mini-btn" @click="saveReview" style="margin:1rem;margin-right: 0;">{{ $t('save_order_review') }}</sf-button>
      </div>
    </confirmModal>
  </div>
</template>

<script>
import confirmModal from '~/components/ContentModal/confirm';
import { ref, computed, onMounted } from '@nuxtjs/composition-api';
import {
  SfButton,
  SfProperty,
  SfLink,
  SfTextarea,
  SfModal,
  SfIcon,
  SfRating,
  SfHeading,
  SfAccordion,
  SfImage
} from '@storefront-ui/vue';
import { useReview, reviewGetters } from '@bee-hole/coms';
import Reviewrating from '~/components/Order/Reviewrating';
import uploadFile from '~/components/util/uploadFile';
export default {
  name: 'Review',
  props: {
    order: {
      type: Object,
      default: {}
    },
    grade: 1,
    goodsId: 0,
    skuId: 0,
    itemName: ''
  },
  components: {
    SfButton,
    SfProperty,
    SfLink,
    SfTextarea,
    SfModal,
    SfIcon,
    SfRating,
    Reviewrating,
    confirmModal,
    uploadFile,
    SfHeading,
    SfAccordion,
    SfImage
  },
  setup(props, context) {
    const afterOrder = ref(JSON.parse(JSON.stringify(props.order)));
    const goodsId = props.goodsId;
    const skuId = props.skuId ? props.skuId : 0;
    // const { set: setError } = useApiError();
    const { addReview, search, reviews } = useReview(
      'productReview_' + goodsId + '_' + skuId
    );
    const newLastOne = computed(() => reviews.value[0]);
    const visible = ref(false);
    // components
    const reviewModal = ref(null);
    const form = ref({
      orderId: afterOrder.value.orderId,
      goodsId: goodsId,
      skuId: skuId,
      grade: 5,
      reviewContent: '',
      images: [],
      videoUrl: ''
    });
    const imageList = ref(['', '', '', '', '']);
    // search({
    //   goods_id: goodsId,
    //   sku_id: skuId,
    //   order_id: afterOrder.value.orderId
    // });
    onMounted(async () => {
      await search({
        goods_id: goodsId,
        sku_id: skuId,
        order_id: afterOrder.value.orderId
      });
    });
    const apply = async () => {
      // visible.value = true;
      form.value.grade = 5;
      reviewModal.value.setModal({
        title: context?.root.$t('order_review'),
        showFooter: false
      });
    };
    const saveReview = async () => {
      // 去掉空的图片
      form.value.images = imageList.value.filter((item) => item);
      await addReview(form.value);
      // visible.value = false;
      // console.log('res', res)
      // if (res && res.review_id){
      //   // setError({ code: 0, message: context?.root.$t('save_review_success') });
      // }
      reviewModal.value.okConfirm();
      // search({
      //   goods_id: goodsId,
      //   sku_id: skuId,
      //   order_id: afterOrder.value.orderId
      // });
    };
    const closeModal = () => {
      visible.value = false;
    };

    const jia1 = (grade) => {
      form.value.grade = grade;
    };
    const jian1 = (grade) => {
      form.value.grade = grade;
    };
    const closeReviewModal = () => {
      reviewModal.value?.close();
    };
    const backVideo = (video) => {
      form.value.videoUrl = video;
    };
    const backImage = (image, index) => {
      imageList.value[index] = image;
    };
    return {
      apply,
      afterOrder,
      form,
      visible,
      closeModal,
      saveReview,
      reviews,
      newLastOne,
      reviewGetters,
      Reviewrating,
      jia1,
      jian1,
      reviewModal,
      closeReviewModal,
      imageList,
      backVideo,
      backImage
    };
  }
};
</script>
<style lang="scss" scoped>
.itemList {
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.afterForm {
  width: 100%;
}

.modalShouHou {
  --modal-width: 65rem;
  --modal-left: 20%;
  --modal-transform: translate3d(-15%, -20%, 0);
  --modal-top: 10%;
}
</style>
<style lang="scss" >
.modalShouHou {
  >.sf-modal__container {
    z-index: 999999999999;
    margin-top: 20px;
  }
}
.reviewModal{
 @include for-desktop{
   --modal-width: 60vw;
  --modal-top: 20rem;
  --modal-max-height: 610px;
  .sf-textarea textarea {
      width: 95%;
      margin-top:0.5rem;
  }
  .sf-modal__container{
    max-width: 850px;
  }
 }
 @include for-mobile{
  --modal-width: 80vw;
  --modal-height: 55vh;
  --modal-top: 5%;
  .sf-textarea textarea {
      width: 85%;
      margin-top:0.5rem;
  }
 }
 .sf-textarea__label{
   margin-bottom: 0.5rem;
 }
}
.reviewDetail{
   .productAcction{
    .sf-accordion-item{
      --tabs-chevron-display: block;
      border-top: 1px solid #CFCFCF;
      .sf-accordion-item__header{
        height: 60px;
        font-weight: 600;
      }
    }
    .sf-chevron--right, .sf-accordion-item__chevron{
      --tabs-chevron-display: block;
    }
  }
}
</style>
